<template>
  <div class="y-toast-host" aria-live="polite">
    <TransitionGroup name="y-toast">
      <div
        v-for="toast in toasts"
        :key="toast.id"
        class="y-toast"
        :class="`y-toast--${toast.type}`"
        role="status"
      >
        <v-icon size="18" class="y-toast__icon">{{ iconFor(toast.type) }}</v-icon>
        <span class="y-toast__message">{{ toast.message }}</span>
        <button
          type="button"
          class="y-toast__close y-focus-visible"
          aria-label="Dismiss"
          @click="dismiss(toast.id)"
        >
          <v-icon size="16">mdi-close</v-icon>
        </button>
      </div>
    </TransitionGroup>
  </div>
</template>

<script setup>
import { useToast } from "@/composables/useToast.js";

const { toasts, dismiss } = useToast();

function iconFor(type) {
  const map = {
    success: "mdi-check-circle-outline",
    error: "mdi-alert-circle-outline",
    warning: "mdi-alert-outline",
    info: "mdi-information-outline",
  };
  return map[type] || map.info;
}
</script>

<style scoped>
.y-toast-host {
  position: fixed;
  top: var(--space-6);
  right: var(--space-6);
  z-index: 9999;
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  max-width: 380px;
}

.y-toast {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  padding: var(--space-3) var(--space-4);
  background: var(--color-card);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-md);
  font-size: var(--font-size-sm);
}

.y-toast--success {
  border-left: 3px solid var(--color-success);
}

.y-toast--error {
  border-left: 3px solid var(--color-error);
}

.y-toast--warning {
  border-left: 3px solid var(--color-warning);
}

.y-toast--info {
  border-left: 3px solid var(--color-primary);
}

.y-toast__message {
  flex: 1;
  color: var(--color-text-primary);
}

.y-toast__close {
  background: none;
  border: none;
  color: var(--color-text-muted);
  cursor: pointer;
  padding: var(--space-1);
  border-radius: var(--radius-sm);
}

.y-toast-enter-active,
.y-toast-leave-active {
  transition: all var(--duration-base) var(--ease-premium);
}

.y-toast-enter-from,
.y-toast-leave-to {
  opacity: 0;
  transform: translateX(12px);
}
</style>
